export default __webpack_public_path__ + "static/media/project3.244239f5.png";